// import React, { useState } from "react";
// import {
//   Box,
//   Grid,
//   Card,
//   Typography,
//   TextField,
//   Button,
//   CircularProgress,
//   InputAdornment,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel
// } from "@mui/material";
// import axios from "axios";
// import ayujalogo from "../../Logos/AuthScreens/AuthLogo.png";
// import Footer from "../../Common/Footer";
// import { useNavigate } from "react-router-dom";
// import CustomDialog from "../../../CustomDialog";
// import EmailIcon from "@mui/icons-material/Email";
// import PhoneIcon from "@mui/icons-material/Phone";

// const ForgotPassword = () => {
//   const navigate = useNavigate();
//   const [step, setStep] = useState(1);
//   const [identifier, setIdentifier] = useState("");
//   const [identifierType, setIdentifierType] = useState("email"); 
//   const [otp, setOtp] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [loading, setLoading] = useState(false);

//   const passwordRequest = process.env.REACT_APP_PASSWORD_REQUEST_API;
//   const verifyOtp = process.env.REACT_APP_VERIFY_OTP_API;
//   const passwordReset = process.env.REACT_APP_PASSWORD_RESET_API;

//   const [validationDialogOpen, setValidationDialogOpen] = useState(false);
//   const [validationMessage, setValidationMessage] = useState("");

//   // Password validation regex
//   const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

//   const validateIdentifier = (identifier, type) => {
//     if (type === "email") {
//       const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//       return emailRegex.test(identifier);
//     } else if (type === "phone") {
//       // Basic phone validation - adjust based on your requirements
//       const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
//       return phoneRegex.test(identifier.replace(/\D/g, '')) && identifier.replace(/\D/g, '').length >= 10;
//     }
//     return false;
//   };

//   const handleSendOtp = async () => {
//     setLoading(true);
    
//     if (!identifier) {
//       setValidationMessage(`Please enter your ${identifierType === "email" ? "email address" : "phone number"}`);
//       setValidationDialogOpen(true);
//       setLoading(false);
//       return;
//     }

//     // Validate identifier format
//     if (!validateIdentifier(identifier, identifierType)) {
//       setValidationMessage(
//         identifierType === "email" 
//           ? "Please enter a valid email address" 
//           : "Please enter a valid phone number"
//       );
//       setValidationDialogOpen(true);
//       setLoading(false);
//       return;
//     }

//     try {
//       const res = await axios.post(passwordRequest, {
//         identifier,
//       });

//       if (res.data.success) {
//         setValidationMessage(
//           identifierType === "email" 
//             ? "OTP sent to your email" 
//             : "OTP sent to your mobile number"
//         );
//         setValidationDialogOpen(true);
//         setStep(2);
//       } else {
//         setValidationMessage(res.data.message || "Please try again.");
//         setValidationDialogOpen(true);
//       }
//     } catch (err) {
//       console.error(err);
//       if (err.response && err.response.data) {
//         setValidationMessage(err.response.data.message || "Failed to send OTP");
//       } else {
//         setValidationMessage("Failed to send OTP. Please try again.");
//       }
//       setValidationDialogOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleVerifyOtp = async () => {
//     setLoading(true);
//     if (!otp) {
//       setValidationMessage("Please enter OTP");
//       setValidationDialogOpen(true);
//       setLoading(false);
//       return;
//     }
//     let finalIdentifier = identifier;

//     if (identifierType === "phone") {
//       const cleanedPhone = identifier.replace(/[\s\-\(\)]/g, "");
//       if (!cleanedPhone.startsWith("+")) {
//         finalIdentifier = "+91" + cleanedPhone;
//       } else {
//         finalIdentifier = cleanedPhone;
//       }
//     }


//     try {
//       const res = await axios.post(verifyOtp, {
//         identifier: finalIdentifier,
//         otp,
//       });

//       if (res.data.success) {
//         setValidationMessage("OTP Verified!");
//         setValidationDialogOpen(true);
//         setStep(3);
//       } else {
//         setValidationMessage(res.data.message || "Invalid OTP");
//         setValidationDialogOpen(true);
//       }
//     } catch (err) {
//       console.error(err);
//       if (err.response && err.response.data) {
//         setValidationMessage(err.response.data.message || "OTP verification failed");
//       } else {
//         setValidationMessage("OTP verification failed");
//       }
//       setValidationDialogOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleResetPassword = async () => {
//     setLoading(true);
    
//     if (!newPassword) {
//       setValidationMessage("Please enter new password");
//       setValidationDialogOpen(true);
//       setLoading(false);
//       return;
//     }

//     if (!confirmPassword) {
//       setValidationMessage("Please confirm your password");
//       setValidationDialogOpen(true);
//       setLoading(false);
//       return;
//     }

//     if (!passwordRegex.test(newPassword)) {
//       setValidationMessage("Password must contain at least one uppercase letter, one number, one special character (@$!%*?&), and be at least 8 characters long.");
//       setValidationDialogOpen(true);
//       setLoading(false);
//       return;
//     }

//     if (newPassword !== confirmPassword) {
//       setValidationMessage("Passwords do not match");
//       setValidationDialogOpen(true);
//       setLoading(false);
//       return;
//     }
//     let finalIdentifier = identifier;

//     if (identifierType === "phone") {
//       const cleanedPhone = identifier.replace(/[\s\-\(\)]/g, "");
//       if (!cleanedPhone.startsWith("+")) {
//         finalIdentifier = "+91" + cleanedPhone;
//       } else {
//         finalIdentifier = cleanedPhone;
//       }
//     }

//     try {
//       const res = await axios.post(passwordReset, {
//         identifier: finalIdentifier,
//         newPassword,
//       });

//       if (res.data.success) {
//         setValidationMessage("Password reset successful!");
//         setValidationDialogOpen(true);
//         setStep(1);
//         setIdentifier("");
//         setOtp("");
//         setNewPassword("");
//         setConfirmPassword("");
//         setIdentifierType("email");
        
//         // Navigate to login after 3 seconds
//         setTimeout(() => {
//           navigate("/login", { replace: true });
//         }, 5000);
//       } else {
//         setValidationMessage(res.data.message || "Password reset failed");
//         setValidationDialogOpen(true);
//       }
//     } catch (err) {
//       console.error(err);
//       if (err.response && err.response.data) {
//         setValidationMessage(err.response.data.message || "Password reset failed");
//       } else {
//         setValidationMessage("Password reset failed");
//       }
//       setValidationDialogOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleIdentifierTypeChange = (type) => {
//     setIdentifierType(type);
//     setIdentifier(""); // Clear identifier when switching types
//   };

//   return (
//     <>
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         p: 5,
//       }}
//     >
//       <Card sx={{ borderRadius: "16px", width: "50vw" }}>
//         <Grid container>
//           {/* Left Section */}
//                     <Grid
//                       item
//                       xs={12}
//                       md={6}
//                       sx={{
//                         background: "linear-gradient(135deg, #004f54, #007a85, #007a85)",
//                         color: "white",
//                         display: "flex",
//                         flexDirection: "column",
//                         justifyContent: "center",
//                         p: 4,
//                         width: "60%"
//                       }}
//             >
//               <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 2 }}>
//             <img
//               src={ayujalogo}
//               alt="Ayuja Logo"
//               style={{
//                 height: "80px",
//                 width: "auto",
//                 display: "block",
//               }}
//             />
//           </Box>

//             <Typography
//               variant="h4"
//               sx={{ fontWeight: "bold", mb: 2, textAlign: "center" }}
//             >
//               Welcome <br />
//               Back to Ayuja
//             </Typography>

//             <Typography
//               variant="h6"
//               sx={{ mb: 2, textAlign: "center" }}
//             >
//               Your trusted partner in personalized in-home care for every stage of life
//             </Typography>

//               <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 3, mb: 4 }}>
//                 <Typography variant="body2" sx={{ display: "flex", alignItems: "center" }}>
//                   ✅ 24/7 Support
//                 </Typography><br />
//                 <Typography variant="body2" sx={{ display: "flex", alignItems: "center" }}>
//                   ✅ Certified Caregivers
//                 </Typography>
//               </Box>

//             <Box
//               sx={{
//                 backgroundColor: "rgba(255, 255, 255, 0.1)",
//                 borderRadius: "12px",
//                 p: 3,
//                 textAlign: "center",
//                 width: "50%",
//                 marginLeft: "100px"
//               }}
//             >
//               <Typography variant="subtitle1" fontWeight="bold" mb={1}>
//                 Emergency Support Available
//               </Typography>
//               <Typography variant="body2" sx={{ mb: 2 }}>
//                 Need immediate assistance? Our emergency support team is available 24/7 to help you
//                 and your loved ones.
//               </Typography>
//               <Button
//                 variant="contained"
//                 onClick={() => navigate("/contactus")}
//                 sx={{
//                   backgroundColor: "#80ED99",
//                   "&:hover": { backgroundColor: "#80ED99" },
//                   color: "#22577A",
//                   textTransform: "none",
//                   borderRadius: "8px",
//                 }}
//               >
//                 Contact Emergency
//               </Button>
//             </Box>
//           </Grid>

//           {/* Right Section */}
//           <Grid
//             item
//             xs={12}
//             md={6}
//             sx={{
//               backgroundColor: "white",
//               p: 4,
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "center",
//               width: "40%",
//             }}
//           >
//             <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
//               Forgot Password
//             </Typography>
//             <Typography variant="body2" sx={{ mb: 3, color: "text.secondary" }}>
//               Follow the steps below to reset your password
//             </Typography>

//             {/* Step 1: Enter Email/Phone */}
//             {step === 1 && (
//               <>
//                 <FormControl fullWidth margin="normal">
//                   <InputLabel>Reset via</InputLabel>
//                   <Select
//                     value={identifierType}
//                     label="Reset via"
//                     onChange={(e) => handleIdentifierTypeChange(e.target.value)}
//                   >
//                     <MenuItem value="email">Email</MenuItem>
//                     <MenuItem value="phone">Phone</MenuItem>
//                   </Select>
//                 </FormControl>

//                 <TextField
//                   label={identifierType === "email" ? "Email Address" : "Phone Number"}
//                   placeholder={
//                     identifierType === "email" 
//                       ? "Enter your registered email" 
//                       : "Enter your registered phone (e.g., +919876543210)"
//                   }
//                   fullWidth
//                   margin="normal"
//                   value={identifier}
//                   onChange={(e) => setIdentifier(e.target.value)}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           {identifierType === "email" ? <EmailIcon /> : <PhoneIcon />}
//                         </InputAdornment>
//                       ),
//                     }}
//                     helperText={
//                       identifierType === "phone" 
//                         ? "Include country code (e.g., +91 for India)" 
//                         : "Enter your registered email address"
//                     }
//                   />
                  
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   sx={{
//                     backgroundColor: "#007a85",
//                     "&:hover": { backgroundColor: "#005f64" },
//                     mt: 2,
//                   }}
//                   onClick={handleSendOtp}
//                   disabled={loading}
//                 >
//                     {loading ? <CircularProgress size={24} color="inherit" /> : "Send OTP"}
//                   </Button>
//                 </>
//               )}

//             {/* Step 2: Enter OTP */}
//             {step === 2 && (
//               <>
//                 <Typography variant="body1" sx={{ mb: 2 }}>
//                   OTP sent to {identifierType === "email" ? "your email" : "your mobile number"}
//                 </Typography>
//                 <TextField
//                   label="Enter OTP"
//                   placeholder="Enter the 6-digit OTP"
//                   fullWidth
//                   margin="normal"
//                   value={otp}
//                   onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
//                   InputProps={{
//                     inputProps: { maxLength: 6 },
//                   }}
//                 />
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   sx={{
//                     backgroundColor: "#007a85",
//                     "&:hover": { backgroundColor: "#005f64" },
//                     mt: 2,
//                   }}
//                   onClick={handleVerifyOtp}
//                   disabled={loading}
//                 >
//                     {loading ? <CircularProgress size={24} color="inherit" /> : "Verify OTP"}
//                 </Button>
                
//                 <Button
//                   variant="text"
//                   fullWidth
//                   sx={{
//                     mt: 1,
//                     color: "#007a85",
//                   }}
//                   onClick={handleSendOtp}
//                   disabled={loading}
//                 >
//                   Resend OTP
//                 </Button>
//               </>
//             )}

//             {/* Step 3: Reset Password */}
//             {step === 3 && (
//               <>
//                 <Typography variant="body1" sx={{ mb: 2 }}>
//                   Reset password for {identifier}
//                 </Typography>
//                 <TextField
//                   label="New Password"
//                   type="password"
//                   placeholder="Enter new password"
//                   fullWidth
//                   margin="normal"
//                   value={newPassword}
//                   onChange={(e) => setNewPassword(e.target.value)}
//                   helperText="Must contain: uppercase, number, special character, 8+ characters"
//                 />
//                 <TextField
//                   label="Confirm Password"
//                   type="password"
//                   placeholder="Confirm new password"
//                   fullWidth
//                   margin="normal"
//                   value={confirmPassword}
//                   onChange={(e) => setConfirmPassword(e.target.value)}
//                 />
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   sx={{
//                     backgroundColor: "#007a85",
//                     "&:hover": { backgroundColor: "#005f64" },
//                     mt: 2,
//                   }}
//                   onClick={handleResetPassword}
//                   disabled={loading}
//                 >
//                     {loading ? <CircularProgress size={24} color="inherit" /> : "Reset Password"}
//               </Button>
//               </>
//             )}

//             {/* Back to Login */}
//             <Button
//               variant="text"
//               fullWidth
//               sx={{
//                 mt: 3,
//                 color: "#007a85",
//               }}
//               onClick={() => navigate("/login")}
//             >
//               Back to Login
//             </Button>
//           </Grid>
//         </Grid>
//       </Card>
//   </Box>
//   <Footer />
//   <CustomDialog
//     open={validationDialogOpen}
//     message={validationMessage}
//     onClose={() => setValidationDialogOpen(false)}
//     title="Message"
//     buttonText="OK"
//   />
// </>
//   );
// };

// export default ForgotPassword;














import React, { useState } from "react";
import {
  Box, Grid, Card, Typography, TextField, Button, CircularProgress,
  InputAdornment, MenuItem, Select, FormControl, InputLabel,
  useMediaQuery, useTheme
} from "@mui/material";
import axios from "axios";
import ayujalogo from "../../Logos/AuthScreens/AuthLogo.png";
import Footer from "../../Common/Footer";
import { useNavigate } from "react-router-dom";
import CustomDialog from "../../../CustomDialog";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));        // < 600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600–900px

  const [step, setStep] = useState(1);
  const [identifier, setIdentifier] = useState("");
  const [identifierType, setIdentifierType] = useState("email");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const passwordRequest = process.env.REACT_APP_PASSWORD_REQUEST_API;
  const verifyOtp = process.env.REACT_APP_VERIFY_OTP_API;
  const passwordReset = process.env.REACT_APP_PASSWORD_RESET_API;

  const [validationDialogOpen, setValidationDialogOpen] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");

  const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const validateIdentifier = (identifier, type) => {
    if (type === "email") {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identifier);
    } else if (type === "phone") {
      const digits = identifier.replace(/\D/g, '');
      return /^[\+]?[1-9][\d]{0,15}$/.test(identifier.replace(/\D/g, '')) && digits.length >= 10;
    }
    return false;
  };

  const showDialog = (msg) => {
    setValidationMessage(msg);
    setValidationDialogOpen(true);
  };

  const handleSendOtp = async () => {
    setLoading(true);
    if (!identifier) {
      showDialog(`Please enter your ${identifierType === "email" ? "email address" : "phone number"}`);
      setLoading(false);
      return;
    }
    if (!validateIdentifier(identifier, identifierType)) {
      showDialog(identifierType === "email" ? "Please enter a valid email address" : "Please enter a valid phone number");
      setLoading(false);
      return;
    }
    try {
      const res = await axios.post(passwordRequest, { identifier });
      if (res.data.success) {
        showDialog(identifierType === "email" ? "OTP sent to your email" : "OTP sent to your mobile number");
        setStep(2);
      } else {
        showDialog(res.data.message || "Please try again.");
      }
    } catch (err) {
      showDialog(err.response?.data?.message || "Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    setLoading(true);
    if (!otp) { showDialog("Please enter OTP"); setLoading(false); return; }

    let finalIdentifier = identifier;
    if (identifierType === "phone") {
      const cleanedPhone = identifier.replace(/[\s\-\(\)]/g, "");
      finalIdentifier = cleanedPhone.startsWith("+") ? cleanedPhone : "+91" + cleanedPhone;
    }

    try {
      const res = await axios.post(verifyOtp, { identifier: finalIdentifier, otp });
      if (res.data.success) {
        showDialog("OTP Verified!");
        setStep(3);
      } else {
        showDialog(res.data.message || "Invalid OTP");
      }
    } catch (err) {
      showDialog(err.response?.data?.message || "OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    setLoading(true);
    if (!newPassword) { showDialog("Please enter new password"); setLoading(false); return; }
    if (!confirmPassword) { showDialog("Please confirm your password"); setLoading(false); return; }
    if (!passwordRegex.test(newPassword)) {
      showDialog("Password must contain at least one uppercase letter, one number, one special character (@$!%*?&), and be at least 8 characters long.");
      setLoading(false);
      return;
    }
    if (newPassword !== confirmPassword) { showDialog("Passwords do not match"); setLoading(false); return; }

    let finalIdentifier = identifier;
    if (identifierType === "phone") {
      const cleanedPhone = identifier.replace(/[\s\-\(\)]/g, "");
      finalIdentifier = cleanedPhone.startsWith("+") ? cleanedPhone : "+91" + cleanedPhone;
    }

    try {
      const res = await axios.post(passwordReset, { identifier: finalIdentifier, newPassword });
      if (res.data.success) {
        showDialog("Password reset successful!");
        setStep(1);
        setIdentifier(""); setOtp(""); setNewPassword(""); setConfirmPassword(""); setIdentifierType("email");
        setTimeout(() => navigate("/login", { replace: true }), 5000);
      } else {
        showDialog(res.data.message || "Password reset failed");
      }
    } catch (err) {
      showDialog(err.response?.data?.message || "Password reset failed");
    } finally {
      setLoading(false);
    }
  };

  const handleIdentifierTypeChange = (type) => {
    setIdentifierType(type);
    setIdentifier("");
  };

  // Shared button style
  const primaryBtnSx = {
    backgroundColor: "#007a85",
    "&:hover": { backgroundColor: "#005f64" },
    mt: 2,
    py: isMobile ? 0.9 : 1.2,
    fontSize: { xs: "13px", md: "15px" },
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "80vh",
          p: { xs: 2, sm: 3, md: 4 },
          backgroundColor: "#fff",
        }}
      >
        <Card
          sx={{
            borderRadius: "16px",
            width: "100%",
            maxWidth: { xs: "100%", sm: "500px", md: "860px" },
            overflow: "hidden",
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
          }}
        >
          <Grid container sx={{ flexWrap: { xs: "wrap", md: "nowrap" } }}>

            {/* ── LEFT SECTION: Branding ── */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                background: "linear-gradient(135deg, #004f54, #007a85)",
                color: "white",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                p: { xs: 3, sm: 3, md: 4 },
                flex: { md: "0 0 50%" },
                maxWidth: { md: "50%" },
              }}
            >
              {/* Logo */}
              <Box sx={{ display: "flex", justifyContent: "center", mb: { xs: 1, md: 2 } }}>
                <img
                  src={ayujalogo}
                  alt="Ayuja Logo"
                  style={{
                    height: isMobile ? "52px" : isTablet ? "64px" : "80px",
                    width: "auto",
                  }}
                />
              </Box>

              {/* Title */}
              <Typography
                variant={isMobile ? "h6" : "h4"}
                sx={{ fontWeight: "bold", mb: { xs: 0.5, md: 2 }, textAlign: "center" }}
              >
                {isMobile ? "Welcome Back to Ayuja" : "Welcome \nBack to Ayuja"}
              </Typography>

              {/* Tagline - hidden on mobile */}
              {!isMobile && (
                <Typography variant="h6" sx={{ mb: 2, textAlign: "center", fontSize: { sm: "14px", md: "18px" } }}>
                  Your trusted partner in personalized in-home care for every stage of life
                </Typography>
              )}

              {/* Feature pills */}
              <Box sx={{ display: "flex", justifyContent: "center", gap: { xs: 2, md: 3 }, mb: { xs: 1.5, md: 4 }, flexWrap: "wrap" }}>
                <Typography variant="body2">✅ 24/7 Support</Typography>
                <Typography variant="body2">✅ Certified Caregivers</Typography>
              </Box>

              {/* Emergency box - hidden on mobile */}
              {!isMobile && (
                <Box
                  sx={{
                    backgroundColor: "rgba(255,255,255,0.1)",
                    borderRadius: "12px",
                    p: { sm: 2, md: 3 },
                    textAlign: "center",
                    width: { sm: "85%", md: "80%" },
                  }}
                >
                  <Typography variant="subtitle1" fontWeight="bold" mb={1}
                    sx={{ fontSize: { sm: "13px", md: "16px" } }}>
                    Emergency Support Available
                  </Typography>
                  {!isTablet && (
                    <Typography variant="body2" sx={{ mb: 2 }}>
                      Need immediate assistance? Our emergency support team is available 24/7 to help you and your loved ones.
                    </Typography>
                  )}
                  <Button
                    variant="contained"
                    onClick={() => navigate("/contactus")}
                    sx={{
                      backgroundColor: "#80ED99",
                      "&:hover": { backgroundColor: "#6dda86" },
                      color: "#22577A",
                      textTransform: "none",
                      borderRadius: "8px",
                      fontSize: { sm: "12px", md: "14px" },
                    }}
                  >
                    Contact Emergency
                  </Button>
                </Box>
              )}

              {/* Mobile emergency CTA */}
              {isMobile && (
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => navigate("/contactus")}
                  sx={{ borderColor: "#80ED99", color: "#80ED99", textTransform: "none", borderRadius: "8px", fontSize: "12px" }}
                >
                  🚨 Contact Emergency
                </Button>
              )}
            </Grid>

            {/* ── RIGHT SECTION: Form ── */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                backgroundColor: "white",
                p: { xs: 3, sm: 4, md: 4 },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                flex: { md: "0 0 50%" },
                maxWidth: { md: "50%" },
              }}
            >
              <Typography variant={isMobile ? "h6" : "h5"} sx={{ fontWeight: "bold", mb: 0.5 }}>
                Forgot Password
              </Typography>
              <Typography variant="body2" sx={{ mb: 3, color: "text.secondary" }}>
                Follow the steps below to reset your password
              </Typography>

              {/* ── STEP 1: Enter Email/Phone ── */}
              {step === 1 && (
                <>
                  <FormControl fullWidth margin="normal" size={isMobile ? "small" : "medium"}>
                    <InputLabel>Reset via</InputLabel>
                    <Select
                      value={identifierType}
                      label="Reset via"
                      onChange={(e) => handleIdentifierTypeChange(e.target.value)}
                    >
                      <MenuItem value="email">Email</MenuItem>
                      <MenuItem value="phone">Phone</MenuItem>
                    </Select>
                  </FormControl>

                  <TextField
                    label={identifierType === "email" ? "Email Address" : "Phone Number"}
                    placeholder={
                      identifierType === "email"
                        ? "Enter your registered email"
                        : "Enter your registered phone (e.g., +919876543210)"
                    }
                    fullWidth
                    margin="normal"
                    value={identifier}
                    onChange={(e) => setIdentifier(e.target.value)}
                    size={isMobile ? "small" : "medium"}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {identifierType === "email" ? <EmailIcon fontSize="small" /> : <PhoneIcon fontSize="small" />}
                        </InputAdornment>
                      ),
                    }}
                    helperText={
                      identifierType === "phone"
                        ? "Include country code (e.g., +91 for India)"
                        : "Enter your registered email address"
                    }
                  />

                  <Button
                    variant="contained"
                    fullWidth
                    sx={primaryBtnSx}
                    onClick={handleSendOtp}
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={22} color="inherit" /> : "Send OTP"}
                  </Button>
                </>
              )}

              {/* ── STEP 2: Enter OTP ── */}
              {step === 2 && (
                <>
                  <Typography variant="body2" sx={{ mb: 1, color: "text.secondary" }}>
                    OTP sent to {identifierType === "email" ? "your email" : "your mobile number"}
                  </Typography>
                  <TextField
                    label="Enter OTP"
                    placeholder="Enter the 6-digit OTP"
                    fullWidth
                    margin="normal"
                    value={otp}
                    size={isMobile ? "small" : "medium"}
                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                    InputProps={{ inputProps: { maxLength: 6 } }}
                  />
                  <Button
                    variant="contained"
                    fullWidth
                    sx={primaryBtnSx}
                    onClick={handleVerifyOtp}
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={22} color="inherit" /> : "Verify OTP"}
                  </Button>

                  <Button
                    variant="text"
                    fullWidth
                    sx={{ mt: 1, color: "#007a85", textTransform: "none", fontSize: { xs: "13px", md: "14px" } }}
                    onClick={handleSendOtp}
                    disabled={loading}
                  >
                    Resend OTP
                  </Button>
                </>
              )}

              {/* ── STEP 3: Reset Password ── */}
              {step === 3 && (
                <>
                  <Typography variant="body2" sx={{ mb: 1, color: "text.secondary", wordBreak: "break-all" }}>
                    Reset password for <strong>{identifier}</strong>
                  </Typography>
                  <TextField
                    label="New Password"
                    type="password"
                    placeholder="Enter new password"
                    fullWidth
                    margin="normal"
                    value={newPassword}
                    size={isMobile ? "small" : "medium"}
                    onChange={(e) => setNewPassword(e.target.value)}
                    helperText="Must contain: uppercase, number, special character, 8+ characters"
                  />
                  <TextField
                    label="Confirm Password"
                    type="password"
                    placeholder="Confirm new password"
                    fullWidth
                    margin="normal"
                    value={confirmPassword}
                    size={isMobile ? "small" : "medium"}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <Button
                    variant="contained"
                    fullWidth
                    sx={primaryBtnSx}
                    onClick={handleResetPassword}
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={22} color="inherit" /> : "Reset Password"}
                  </Button>
                </>
              )}

              {/* Back to Login */}
              <Button
                variant="text"
                fullWidth
                sx={{
                  mt: 2,
                  color: "#007a85",
                  textTransform: "none",
                  fontSize: { xs: "13px", md: "14px" },
                }}
                onClick={() => navigate("/login")}
              >
                ← Back to Login
              </Button>
            </Grid>
          </Grid>
        </Card>
      </Box>

      <Footer />

      <CustomDialog
        open={validationDialogOpen}
        message={validationMessage}
        onClose={() => setValidationDialogOpen(false)}
        title="Message"
        buttonText="OK"
      />
    </>
  );
};

export default ForgotPassword;